/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GeneratedMutationMetadata } from "./GeneratedMutationMetadata";
export const GeneratedMutation = core.serialization.object({
    mutateRecord: core.serialization.string(),
    metadata: GeneratedMutationMetadata,
    mutationId: core.serialization.string(),
});
